import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames/bind';
import styles from './CloseIcon.scss';

const cx = classNames.bind(styles);

/**
 * @deprecated, use @ott/icon-cross, @ott/icon-small-cross instead
 */
class CloseIcon extends PureComponent {
  static propTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
    size: PropTypes.oneOf(['normal', 'large']),
  };

  static defaultProps = {
    size: 'normal',
    width: 24,
    height: 24,
  };

  renderPath() {
    const { size } = this.props;

    switch (size) {
      case 'large':
        return (
          <path
            d="M12 10.94l7.47-7.47a.75.75 0 0 1 1.06 1.06L13.06 12l7.47 7.47a.75.75 0 0 1-1.06 1.06L12 13.06l-7.47 7.47a.75.75 0 0 1-1.06-1.06L10.94 12 3.47 4.53a.75.75 0 0 1 1.06-1.06L12 10.94z"
            fillRule="evenodd"
          />
        );

      default:
        return (
          <path d="M12 10.94l4.47-4.47a.75.75 0 0 1 1.06 1.06L13.06 12l4.47 4.47a.75.75 0 0 1-1.06 1.06L12 13.06l-4.47 4.47a.75.75 0 0 1-1.06-1.06L10.94 12 6.47 7.53a.75.75 0 0 1 1.06-1.06L12 10.94z" />
        );
    }
  }

  render() {
    const { width, height, className, onClick, onTouchEnd, ...restProps } = this.props;

    return (
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        preserveAspectRatio="xMinYMin"
        xmlns="http://www.w3.org/2000/svg"
        className={cx('CloseIcon', className)}
        onClick={onClick}
        onTouchEnd={onTouchEnd}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...restProps}
      >
        {this.renderPath()}
      </svg>
    );
  }
}

CloseIcon.IS_DEPRECATED = true;

export default CloseIcon;
